import { Form, Modal, Switch } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import dayjs from 'dayjs'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import bufferToFileDownload from '@utils/download'

import TenantAPI from '@apis/branch/tenant'

import { RootState } from '@reducers/index'

import Loading from '@components/molecules/Loading'

type Props = {
  hqId: number
  branchId: number
  visible: boolean
  onDone?: () => void
  onClose: () => void
}

export default function TenantExportModal({ hqId, branchId, visible, onClose, onDone }: Props): JSX.Element {
  const [form] = useForm<{ includeExpired: boolean }>()
  const [loading, setLoading] = useState(false)
  const branchName = useSelector((state: RootState) => state.branch.name)

  const onOk = async () => {
    try {
      setLoading(true)
      const { includeExpired } = await form.validateFields()
      const { data } = await TenantAPI.exportTenants({ hqId, branchId }, { includeExpired })

      const today = dayjs().format('YYMMDD')
      bufferToFileDownload(`${branchName}_입주사_${today}.xlsx`, Buffer.from(data))

      setLoading(false)
      onClose()
    } catch (err) {
      setLoading(false)
    }
  }

  return (
    <Modal
      title="입주사 다운로드"
      visible={visible}
      onCancel={onClose}
      okText="다운로드"
      onOk={onOk}
      confirmLoading={loading}
      width="400px"
    >
      <Loading loading={loading}>
        <Form form={form} layout="vertical">
          <Form.Item label="계약 종료 된 입주사 포함" name="includeExpired">
            <Switch />
          </Form.Item>
        </Form>
      </Loading>
    </Modal>
  )
}
